import React, {FC} from 'react';
import styles from './FAQs.module.scss';
import {HashLink as Link} from 'react-router-hash-link';
import {Helmet} from "react-helmet";

interface FaQsProps {
}

const FaQs: FC<FaQsProps> = () => (

    <><Helmet>
        <meta charSet="utf-8"/>
        <title>FAQs</title>
    </Helmet>
        <div className={styles.FaQs}>
            <div className="standard-margin">

                <h1>Frequently Asked Questions</h1>
                <hr></hr>
                <p className={styles.question}>Q. What materials make up the Technical Information Center's
                    collections?</p>
                <p className={styles.answer}>A. The collection consists mainly of planning and construction documents
                    created for
                    and by the National Park Service (<abbr>NPS</abbr>). The collection also includes publications on
                    cultural and natural resources.</p>

                <p className={styles.question}>Q. How do I export search results?</p>
                <p className={styles.answer}>A. Use the Excel icon at the top right of the results grid. A spreadsheet
                    will
                    appear.<Link to={"./../helppage#1"}>View Help</Link></p>

                <p className={styles.question}>Q. How do I download materials?</p>
                <p className={styles.answer}>A. Select the record you are interested in and then click on the thumbnail
                    image.If the record contains more than one <abbr title="Portable Document Format">PDF</abbr> file,
                    the additional documents will be displayed
                    under ‘Documents in Set’.<Link to={"./../helppage#view"}>View Help</Link></p>


                <p className={styles.question}>Q. What if the item I want does not have a scan attached?</p>
                <p className={styles.answer}>A.If an item does not have a scan attached, contact us via <Link
                    to={"./../teams"}> Contact Us</Link> page.by email: <a href="mailto:etic.nps.gov" target="_blank"
                                                                           id="anch_40">etic.nps.gov</a>, or by
                    phone: 303‑969‑2130.</p>

                <p className={styles.question}>Q. How do I contact the Technical Information Center (TIC) if I have a
                    problem or can't find the answer to my question?</p>
                <p className={styles.answer}>Please <Link to={"./../Teams"}> Contact Us </Link> with comments,
                    suggestions, questions or to report an issue.</p>

                <p className={styles.question}>Q.How do I share <abbr>e</abbr>TIC (electronic Technical Information
                    Center)
                    items with others?</p>
                <p className={styles.answer}>A. You can easily send your search results to your colleagues through our
                    “Share” link(s) located on Records Details.<Link to={"./../helppage#view"}>View Help</Link></p>

                <p className={styles.question}>Q. What is a "Wayside Exhibit"?</p>
                <p className={styles.answer}>A. Wayside Exhibits are the printed materials used to inspire a connection
                    between the park visitor and the park resource. They are located directly adjacent to features on
                    the
                    landscape and foster an immediate and direct association of information and place.</p>

                <p className={styles.question}>Q. The search filter offers to ‘Enter Security Type’, can you please
                    explain
                    the security classifications?</p>
                <p className={styles.answer}>A.This information can be found in the <Link
                    to="./../securityguidelines"> Security Guidelines </Link></p>

                <p className={styles.question}>Q. How can I submit some of my documents to the Technical Information
                    Center
                    (TIC)?</p>
                <p className={styles.answer}>A.This information can be found on the <Link to="./../fileupload">File
                    Upload</Link> page.<Link to="./../helppage#1">View Help</Link></p>

                <p className={styles.question}>Q. What if I need to send hard copies of my drawings and illustrations to
                    the
                    Technical Information Center (TIC)?</p>
                <p className={styles.answer}>A. Instructions on how to package and send your materials can be found on
                    the
                    <Link to="./../workingwithtic"> Working with TIC</Link> webpage.</p>

                <p className={styles.question}>Q. TIC requests a 3 digit park code when shipping materials — where can I
                    find that information?</p>
                <p className={styles.answer}>A.Your 3 digit park code is located on the <Link to="./../parkindex"> Park
                    Region</Link> page.</p>

                <p className={styles.question}>Q. What is the advantage of the Technical Information Center (TIC)
                    archiving
                    my materials?</p>
                <p className={styles.answer}>A.<Link to="./../workingwithtic"> Archiving with TIC</Link> has many
                    important
                    advantages.</p>
                <br></br> <br></br> <br></br>
                <hr className="clearRule"></hr>
            </div>


        </div>
    </>
);


export default FaQs;
